var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_c('div',{attrs:{"id":"notice"}},[_c('h5',[_vm._v(_vm._s(_vm.html_title)+"使用说明:"),_c('br'),_c('p',{domProps:{"innerHTML":_vm._s(_vm.html_note)}})])])]),_c('pre-base',{ref:"mybase",attrs:{"pre_data":_vm.init_data},on:{"base2-event":_vm.refresh_father}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }